import * as React from 'react';
import type { SVGProps } from 'react';
const SvgSorting = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M7.03 2.466a.75.75 0 0 1 0 1.059L5.81 4.743H16a.75.75 0 1 1 0 1.497H5.81l1.22 1.218a.75.75 0 0 1 0 1.059.75.75 0 0 1-1.06 0L2.94 5.49l3.03-3.025a.75.75 0 0 1 1.06 0Zm5.94 8.985a.75.75 0 0 0 0 1.06l1.22 1.217H4a.75.75 0 1 0 0 1.498h10.19l-1.22 1.217a.75.75 0 0 0 0 1.06.75.75 0 0 0 1.06 0l3.03-3.026-3.03-3.026a.75.75 0 0 0-1.06 0"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgSorting;
